import { render, staticRenderFns } from "./BaseCustomTelInput.vue?vue&type=template&id=1b5c0bd2&scoped=true&"
import script from "./BaseCustomTelInput.vue?vue&type=script&lang=js&"
export * from "./BaseCustomTelInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseCustomTelInput.vue?vue&type=style&index=0&id=1b5c0bd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c0bd2",
  null
  
)

export default component.exports